
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/dogprofile",
      function () {
        return require("private-next-pages/dogprofile.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/dogprofile"])
      });
    }
  